import { Card, Button, Row, Col } from 'reactstrap';
import {
  // useCustomerSessionList,
  useCustomerSessionListExport,
} from '../../../utils/queries/customerQueries';
import {
  localDate,
  humanizeDurationnHoursMinutes,
  calculatePageOffset,
  seperateNumbersWithCommas,
  getIST,
} from '../../../utils/misc';
import { Spin, Table, Typography } from 'antd';
import '../gridStyle.css';
import { useState } from 'react';
import { toNumber } from 'lodash';
import { CSVLink } from 'react-csv';
import { useRef } from 'react';
import { get } from 'lodash';
import { map } from 'lodash';
import CustomerChargingSessionModal from 'components/Modals/CustomerChargingSessionModal';
import { sumBy } from 'lodash';

const { Text } = Typography;

export const ChargingSessionsGridCustomer = ({ startDate, endDate }) => {
  const [customerSessionsPageNum, setCustomerSessionsPageNum] = useState(1);
  const [selectedCustomerSession, setSelectedCustomerSession] = useState({});
  const [
    customerChargingSessionModalOpen,
    setCustomerChargingSessionModalOpen,
  ] = useState(false);
  const toggleCustomerChargingSessionModal = () =>
    setCustomerChargingSessionModalOpen(!customerChargingSessionModalOpen);
  const csvLinkRef = useRef();
  const [limit, setLimit] = useState(10);
  const [sortOrder, setSortOrder] = useState('ascend');
  const [orderBy, setOrderBy] = useState('START_DATE');

  // const { data: sessionsResp, isLoading } = useCustomerSessionList({
  //   limit,
  //   offset: calculatePageOffset(limit, customerSessionsPageNum),
  //   startDate,
  //   endDate,
  // });
  // const { data: sessions, count } = sessionsResp || {};

  const { data: exportSessionsResp, isLoading } = useCustomerSessionListExport({
    limit,
    offset: calculatePageOffset(limit, customerSessionsPageNum),
    startDate,
    endDate,
    orderBy,
    sortOrder: getSortOrder(),
  });
  const { data: sessions, count } = {
    data: exportSessionsResp,
    count: exportSessionsResp?.length || 0,
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'TRANSACTIONID',
      visibility: true,
      render: (text, session) => (
        <span
          style={{ fontWeight: 600, color: '#317ffe' }}
          onClick={() => {
            setSelectedCustomerSession(session);
            setCustomerChargingSessionModalOpen(true);
          }}
        >
          {session?.NOTE?.TRANSACTION?.TRANSACTIONID}
        </span>
      ),
      key: 'TRANSACTIONID',
    },
    {
      title: 'KWH CONSUMED',
      dataIndex: 'KWH_CONSUMED',
      visibility: true,
      render: (text, session) => (
        <>{toNumber(session?.NOTE?.KWH?.KWH_CONSUMED).toFixed(2)}kWh</>
      ),
      sorter: (a, b) => a?.NOTE?.KWH?.KWH_CONSUMED - b?.NOTE?.KWH?.KWH_CONSUMED,
      key: 'KWH_CONSUMED',
    },
    {
      title: 'DURATION',
      dataIndex: 'DURATION',
      visibility: true,
      render: (text, session) => (
        <>{humanizeDurationnHoursMinutes(session?.NOTE?.DURATION).string}</>
      ),
      sorter: (a, b) => a?.NOTE?.DURATION - b?.NOTE?.DURATION,
      key: 'DURATION',
    },
    {
      title: 'AMOUNT BILLED',
      dataIndex: 'AMOUNT_CONSUMED',
      visibility: true,
      render: (text, session) => (
        <>
          ₹
          {seperateNumbersWithCommas(
            (toNumber(session?.NOTE?.AMOUNT?.AMOUNT_CONSUMED) / 100).toFixed(2),
          )}
        </>
      ),

      sorter: (a, b) =>
        a?.NOTE?.AMOUNT?.AMOUNT_CONSUMED - b?.NOTE?.AMOUNT?.AMOUNT_CONSUMED,

      key: 'AMOUNT_CONSUMED',
    },
    {
      title: 'STARTED AT',
      dataIndex: 'START_TIME',
      visibility: true,
      render: (text, session) => (
        <>{localDate(getIST(session?.NOTE?.TRANSACTION?.START_TIME))}</>
      ),

      sorter: (a, b) =>
        new Date(a?.NOTE?.TRANSACTION?.START_TIME) -
        new Date(b?.NOTE?.TRANSACTION?.START_TIME),
      defaultSortOrder: 'ascend',
      key: 'START_TIME',
    },
    {
      title: 'ENDED AT',
      dataIndex: 'END_TIME',
      visibility: true,
      render: (text, session) => (
        <>{localDate(getIST(session?.NOTE?.TRANSACTION?.END_TIME))}</>
      ),
      sorter: (a, b) =>
        new Date(a?.NOTE?.TRANSACTION?.END_TIME) -
        new Date(b?.NOTE?.TRANSACTION?.END_TIME),
      key: 'END_TIME',
    },
    {
      title: 'CHARGER ID',
      dataIndex: 'CPID',
      visibility: true,
      render: (text, session) => <>{session?.NOTE.TRANSACTION.CPID}</>,
      key: 'CPID',
    },
  ];

  function getSortOrder() {
    let order = '';
    if (sortOrder === 'ascend') {
      order = 'ASC';
    } else if (sortOrder === 'descend') {
      order = 'DESC';
    }
    return order;
  }

  const sumByKey = (sesData, key) => sumBy(sesData, key);

  const getTotals = (mySessions) => {
    return {
      total_KWH_CONSUMED: sumByKey(mySessions, 'NOTE.KWH.KWH_CONSUMED'),
      total_DURATION: sumByKey(mySessions, 'NOTE.DURATION'),
      total_AMOUNT_ADDED: sumByKey(mySessions, 'NOTE.AMOUNT.AMOUNT_ADDED'),
      total_AMOUNT_REFUNDED: sumByKey(
        mySessions,
        'NOTE.AMOUNT.AMOUNT_REFUNDED',
      ),
      total_AMOUNT_CONSUMED: sumByKey(
        mySessions,
        'NOTE.AMOUNT.AMOUNT_CONSUMED',
      ),
      total_AMOUNT_TAX: sumByKey(mySessions, 'NOTE.AMOUNT.AMOUNT_TAX'),
      total_AMOUNT_CONSUMED_EXCLUSIVE_TAX:
        sumByKey(mySessions, 'NOTE.AMOUNT.AMOUNT_CONSUMED') -
        sumByKey(mySessions, 'NOTE.AMOUNT.AMOUNT_TAX'),
    };
  };

  function generateChargingSessionsCsvData(mySessions) {
    if (!mySessions || mySessions?.length === 0) return [];
    let formattedSessions = map(mySessions, (session) => {
      return {
        'TRANSACTION ID': get(session, 'NOTE.TRANSACTION.TRANSACTIONID'),
        'CHARGER NAME': get(session, 'NOTE.CHARGER.NAME'),
        'CHARGER ID': get(session, 'NOTE.CHARGER.ID'),
        ADDRESS: get(session, 'NOTE.CHARGER.ADDRESS'),
        'CONNECTOR ID': get(session, 'NOTE.TRANSACTION.CONNECTORID'),
        'UNITS CONSUMED': `${toNumber(
          get(session, 'NOTE.KWH.KWH_CONSUMED'),
        ).toFixed(2)} kWh`,
        TARIFF: `₹ ${get(session, 'NOTE.AMOUNT.AVG_PRICE') / 100}`,
        'CHARGING STARTED AT': localDate(
          getIST(get(session, 'NOTE.TRANSACTION.START_TIME')),
        ),
        'CHARGING ENDED AT': localDate(
          getIST(get(session, 'NOTE.TRANSACTION.END_TIME')),
        ),
        DURATION: humanizeDurationnHoursMinutes(get(session, 'NOTE.DURATION'))
          .string,
        'ORDER ID':
          get(session, 'EXTRA.payload.payment.entity.order_id') ||
          get(session, 'ID'),
        'AMOUNT ADDED IN WALLET': `₹ ${(
          toNumber(get(session, 'NOTE.AMOUNT.AMOUNT_ADDED')) / 100
        ).toFixed(2)}`,
        'AMOUNT REFUNDED': `₹ ${(
          toNumber(get(session, 'NOTE.AMOUNT.AMOUNT_REFUNDED')) / 100
        ).toFixed(2)}`,
        'AMOUNT CONSUMED EXCLUSIVE TAX': `₹ ${(
          toNumber(get(session, 'NOTE.AMOUNT.AMOUNT_CONSUMED')) / 100 -
          toNumber(get(session, 'NOTE.AMOUNT.AMOUNT_TAX')) / 100
        ).toFixed(2)}`,
        'TAX ON AMOUNT CONSUMED(18.0% GST)': `₹ ${(
          toNumber(get(session, 'NOTE.AMOUNT.AMOUNT_TAX')) / 100
        ).toFixed(2)}`,
        'NET TOTAL': `₹ ${toNumber(
          get(session, 'NOTE.AMOUNT.AMOUNT_CONSUMED') / 100,
        ).toFixed(2)}`,
      };
    });

    // const total_KWH_CONSUMED = sumByKey(mySessions, 'NOTE.KWH.KWH_CONSUMED');
    // const total_DURATION = sumByKey(mySessions, 'NOTE.DURATION');
    // const total_AMOUNT_ADDED = sumByKey(mySessions, 'NOTE.AMOUNT.AMOUNT_ADDED');
    // const total_AMOUNT_REFUNDED = sumByKey(
    //   mySessions,
    //   'NOTE.AMOUNT.AMOUNT_REFUNDED',
    // );
    // const total_AMOUNT_CONSUMED = sumByKey(
    //   mySessions,
    //   'NOTE.AMOUNT.AMOUNT_CONSUMED',
    // );
    // const total_AMOUNT_TAX = sumByKey(mySessions, 'NOTE.AMOUNT.AMOUNT_TAX');
    // const total_AMOUNT_CONSUMED_EXCLUSIVE_TAX =
    //   total_AMOUNT_CONSUMED - total_AMOUNT_TAX;

    const {
      total_KWH_CONSUMED,
      total_DURATION,
      total_AMOUNT_ADDED,
      total_AMOUNT_REFUNDED,
      total_AMOUNT_CONSUMED,
      total_AMOUNT_TAX,
      total_AMOUNT_CONSUMED_EXCLUSIVE_TAX,
    } = getTotals(mySessions);

    const rowOfTotals = {
      'TRANSACTION ID': '',
      'CHARGER NAME': '',
      'CHARGER ID': '',
      ADDRESS: '',
      'CONNECTOR ID': 'Total',
      'UNITS CONSUMED': `${toNumber(total_KWH_CONSUMED).toFixed(2)} kWh`,
      TARIFF: '',
      'CHARGING ENDED AT': '',
      DURATION: humanizeDurationnHoursMinutes(total_DURATION).string,
      'AMOUNT ADDED IN WALLET': `₹ ${(total_AMOUNT_ADDED / 100).toFixed(2)}`,
      'AMOUNT REFUNDED': `₹ ${toNumber(total_AMOUNT_REFUNDED / 100).toFixed(
        2,
      )}`,
      'AMOUNT CONSUMED EXCLUSIVE TAX': `₹ ${(
        toNumber(total_AMOUNT_CONSUMED_EXCLUSIVE_TAX) / 100
      ).toFixed(2)}`,
      'TAX ON AMOUNT CONSUMED(18.0% GST)': `₹ ${(
        toNumber(total_AMOUNT_TAX) / 100
      ).toFixed(2)}`,
      'NET TOTAL': `₹ ${toNumber(total_AMOUNT_CONSUMED / 100).toFixed(2)}`,
    };
    formattedSessions.push(rowOfTotals);
    return formattedSessions;
  }

  const exportToCSV = () => {
    csvLinkRef?.current?.link.click();
  };

  const getTitle = () => {
    return (
      <div className="d-flex justify-content-space-between align-items-center">
        {sessions && (
          <>
            <h3 className="mb-0">
              My Charging Sessions{' '}
              <span style={{ fontSize: '12px', fontWeight: 'normal' }}>
                ({startDate} - {endDate})
              </span>
            </h3>

            <div className="d-flex justify-content-end  align-items-center">
              <div style={{ marginRight: 10, fontWeight: 400 }}>
                (Total Sessions: {count})
              </div>
              <Button className="jp-csv-button" onClick={exportToCSV}>
                {' '}
                Export as CSV
              </Button>
              <CSVLink
                ref={csvLinkRef}
                data={generateChargingSessionsCsvData(exportSessionsResp)}
                filename="ChargingSessions.csv"
                separator=","
                className="csv-button"
                style={{
                  display: 'none',
                }}
              >
                Export as CSV
              </CSVLink>
            </div>
          </>
        )}
      </div>
    );
  };

  const getSummary = () => {
    if (!(sessions || sessions?.length > 0)) return null;

    const { total_KWH_CONSUMED, total_DURATION, total_AMOUNT_CONSUMED } =
      getTotals(exportSessionsResp);
    return (
      <Table.Summary fixed>
        <Table.Summary.Row fixed style={{ fontWeight: '600' }}>
          <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
          <Table.Summary.Cell index={1}>
            <Text>
              {total_KWH_CONSUMED
                ? `${toNumber(total_KWH_CONSUMED).toFixed(2)} KWh`
                : 0}
            </Text>
          </Table.Summary.Cell>

          <Table.Summary.Cell index={3}>
            <Text>
              {total_DURATION ? `${toNumber(total_DURATION).toFixed(0)} m` : 0}
            </Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={4}>
            <Text>
              <Text>
                {total_AMOUNT_CONSUMED
                  ? `₹${seperateNumbersWithCommas(
                      (toNumber(total_AMOUNT_CONSUMED) / 100).toFixed(2),
                    )}`
                  : 0}
              </Text>
            </Text>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      </Table.Summary>
    );
  };

  return (
    <div>
      <Row style={{ marginTop: '40px' }}>
        <Col className="order-xl-1" xl="12">
          <Card className="shadow">
            <Spin tip="Fetching Charging Sessions" spinning={isLoading}>
              {!isLoading && (
                <Table
                  rowKey="key"
                  className="cs-grid table-striped-rows shadow"
                  // size="small"
                  tableLayout="fixed"
                  loading={isLoading}
                  sscroll={{ y: 350, x: 'max-content' }}
                  columns={columns}
                  dataSource={sessions || []}
                  scroll={{ y: '40vh' }}
                  style={{ border: '1px solid #e7e7e9' }}
                  title={() => getTitle()}
                  pagination={{
                    current: customerSessionsPageNum,
                    defaultCurrent: 1,
                    pageSize: limit,
                    total: count,
                    hideOnSinglePage: limit >= count,
                  }}
                  summary={(tableData) => getSummary()}
                  onChange={(pagination, filters, sorter) => {
                    setLimit(pagination.pageSize);
                    setSortOrder(sorter.order);
                    setOrderBy(sorter.columnKey);
                    setCustomerSessionsPageNum(pagination.current);
                  }}
                />
              )}
            </Spin>
          </Card>
        </Col>
      </Row>

      <CustomerChargingSessionModal
        toggleModalOpen={toggleCustomerChargingSessionModal}
        modalOpen={customerChargingSessionModalOpen}
        selectedSession={selectedCustomerSession}
      />
    </div>
  );
};
